export const formatListsPrice = (price: string | number) =>
	Math.round(Number(price));

export const formatCartPrice = (price: string | number) =>
	Number.isInteger(Number(price))
		? price
		: parseFloat(price.toString()).toFixed(2);
